/**
 * Full page reload, isolated in its own module so it can be stubbed in tests
 * (jsdom's window.location.reload is non-configurable and can't be spied).
 */
export function reloadWebApp() {
  window.location.reload();
}
